/**
 * Outs Component
 */

import React from 'react';
import { OutsProps } from './outs.types';
import { StyledBaseSVG } from './outs.style';
import COLORS from '../../style/universal.color';

const { outsYellow, outGrey } = COLORS;

// Retrieve orange for an out, grey for not filled
const retrieveOutFill = (outCount: number, out: number, outsActiveColor: string, outsInactiveColor: string) =>
  outCount >= out ? outsActiveColor : outsInactiveColor;

// Utility function to set active className
const checkActiveClass = (outCount: number, out: number) => (outCount >= out ? { className: 'isOut' } : null);

const Outs = ({
  outCount = 0,
  width = 24,
  altText,
  className,
  outsInactiveColor = outGrey,
  outsActiveColor = outsYellow,
  outPadding = 5,
  outSize = 2.5,
  stroke = false,
}: OutsProps) => {
  const strokeSize = stroke ? outSize / 2 : 0;
  const viewBoxBump = stroke ? strokeSize * 2 : 0;
  const outWithStroke = outSize + strokeSize;

  const viewBox: string = `0 0 ${outSize * 6 + outPadding * 2 + viewBoxBump} ${outSize * 2 + viewBoxBump}`; // adding 2 to account for the stroke on either end.
  const imgAltText: string = altText || `${outCount} outs`;

  // Display the outs as SVG circles.
  return (
    <StyledBaseSVG
      width={width}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox={viewBox}
      tabIndex={-1}
      aria-label={imgAltText || 'outs'}
      strokeColor={stroke ? outsActiveColor : 'unset'}
      strokeSize={strokeSize}
    >
      <title>{imgAltText}</title>
      <circle
        cx={outWithStroke}
        cy={outWithStroke}
        r={outSize}
        fill={retrieveOutFill(outCount, 1, outsActiveColor, outsInactiveColor)}
        {...checkActiveClass(outCount, 1)}
      />
      <circle
        cx={outSize * 3 + outPadding + strokeSize}
        cy={outWithStroke}
        r={outSize}
        fill={retrieveOutFill(outCount, 2, outsActiveColor, outsInactiveColor)}
        {...checkActiveClass(outCount, 2)}
      />
      <circle
        cx={outSize * 5 + outPadding * 2 + strokeSize}
        cy={outWithStroke}
        r={outSize}
        fill={retrieveOutFill(outCount, 3, outsActiveColor, outsInactiveColor)}
        {...checkActiveClass(outCount, 3)}
      />
    </StyledBaseSVG>
  );
};

export default Outs;
